export default __webpack_public_path__ + "static/italie-636c5634b4ca437d36a57dcd2a49a2fd.jpg";